import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Grid, Typography, Button, useMediaQuery } from '@material-ui/core';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// STORE
import { AuthActions } from '@/store/actions';

// STYLES
import { Container } from './styles';

const SMImg = getS3ImageUrl('/home/partner-streaming-tv-guide.png');

const ShowsAndMovies = ({ partner }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  function handleCreateProfile() {
    const data = { screen: 'registration' };

    dispatch(AuthActions.authDrawerOpen.action({ data }));
  }

  return (
    <Container className="section shows-movies">
      <div className="page-content">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} sm={6}>
            <div className="shows-movies__img">
              <img src={SMImg} alt="shows-movies" />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography className="text-bold m-b-10" component="h2" variant={downXs ? 'h4' : 'h2'}>
              {partner?.text_overwrites?.tv_shows_movies_title || t('partnerTV.showsMovies.title')}
            </Typography>
            <Typography className="m-b-30" variant="subtitle2">
              {partner?.text_overwrites?.tv_shows_movies_subtitle ||
                t('partnerTV.showsMovies.subtitle')}
            </Typography>
            <ul className="pros-cons-list pros-cons-list--square-icons">
              <li className="pcl-item">
                <i className="icon-check" />
                {partner?.text_overwrites?.tv_shows_movies_bullet_1 ||
                  t('partnerTV.showsMovies.features.item1')}
              </li>
              <li className="pcl-item">
                <i className="icon-check" />
                {partner?.text_overwrites?.tv_shows_movies_bullet_2 ||
                  t('partnerTV.showsMovies.features.item2')}
              </li>
              <li className="pcl-item">
                <i className="icon-check" />
                {partner?.text_overwrites?.tv_shows_movies_bullet_3 ||
                  t('partnerTV.showsMovies.features.item3')}
              </li>
              <li className="pcl-item">
                <i className="icon-check" />
                {partner?.text_overwrites?.tv_shows_movies_bullet_4 ||
                  t('partnerTV.showsMovies.features.item4')}
              </li>
            </ul>
            <Button
              onClick={handleCreateProfile}
              className="m-t-30"
              size={clsx(downXs ? 'medium' : 'large')}
              color="primary"
            >
              {partner?.text_overwrites?.tv_shows_movies_button_text || t('buttons.createAProfile')}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

ShowsAndMovies.propTypes = {
  partner: PropTypes.object.isRequired,
};

export default React.memo(ShowsAndMovies);
